export default __webpack_public_path__ + "static/media/Space_Design-small.d07cf192.jpeg";